// Hit detection for hover and sizer point interactions

import type { SizerPoint, MousePosition } from '@/modules/Node';

export function checkHovered(
  ctxPath: CanvasRenderingContext2D,
  pathInteraction: Path2D | null,
  mouse: MousePosition,
  hiddenLocal: boolean,
): boolean | null {
  if (!pathInteraction) return false;
  return !hiddenLocal ? ctxPath.isPointInPath(pathInteraction, mouse.x, mouse.y) : null;
}

export function checkSizerPointHovered(
  selectedPoints: SizerPoint[],
  mouse: MousePosition,
  isMobile: boolean = false,
): SizerPoint | null {
  for (let i = 0; i < selectedPoints.length; i++) {
    const point = selectedPoints[i];
    if (isMobile) point.radius = 20;
    if (isPointInCircle(mouse.x, mouse.y, point)) {
      return point;
    }
  }
  return null;
}

function isPointInCircle(x: number, y: number, circle: { x: number; y: number; radius: number }): boolean {
  const dx = x - circle.x;
  const dy = y - circle.y;
  return dx * dx + dy * dy < circle.radius * circle.radius;
}
